import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { fetchIncomeEventsSuccess, fetchIncomeEventsError, FETCH_INCOME_EVENTS } from './actions';

export const fetchIncomeEventsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_INCOME_EVENTS),
    flatMap(() =>
      ajax
        .getJSON('/content/workplace/en/participant/ri/content-pages/income-events.model.json')
        .pipe(map((res: any) => fetchIncomeEventsSuccess(res[`:items`].root[`:items`].contentfragmentlist.items)))
        .pipe(catchError(ex => of(fetchIncomeEventsError(ex)))),
    ),
  );
